/**
 * PC_PC_01 importig the api functions and components
 */
import { useState, useEffect } from 'react';
import React from 'react';
import moment from 'moment';
import Profile from './Profile';
import SalaryRevisionGrid from './SalaryRevisionGrid';
import OnboardingDetails from './OnboardingGrid';
import EmployeeInfo from './EmployeeInfo';
import DependentDetails from './DependentForm';
import OffboardingGrid from '../components/OffboardingGrid';
import ProfileFeedbackTabGrid from './ProfileFeedbackTab';
import AddFeedback from './AddFeedbackForm';
import {
    getEmployeePrimaryInfo,
    getProfileAndCoverImage,
    getEmployeeDependentInfo,
    postCoverImage,
    getReportingEmpId,
    postUploadFile,
} from '../service/DirectorAPI';
import { useNavigate } from 'react-router-dom';
import '../components/custom';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import { Upload, uploadBackend } from '../utils/Upload';
import Loader from '../StaticComponent/Loader';
import MyGoal from './MyGoal';
import { Goal } from '../service/PerformanceAPI';
import Touchbase from '../containers/Touchbase/Touchbase';
import EvaluationButton from './EvaluationButton';
import Wfh from '../containers/WFH/Wfh';
import { getLeaveInED } from '../service/WfhAPI';

import { getOffboardingDataUser} from '../service/DirectorAPI';
import { set } from 'react-hook-form';
import EvaluationPopUp from './EvaluationPopUp';
import { encryptStorage } from '../constant';
import { getS3 } from '../utils/Download.js';

/**
 *
 * PC_PC_03 this function will return the html
 */
function ProfileContainer() {
    /**
     * PC_PC_02 creating state variables and array
     */
    const navigate = useNavigate();
    let session = {
        login_id: '',
        role: '',
    };

    const [sessionData, setSession] = useState(session);
    const [employeeData, setEmployeeData] = useState(session);
    const [customEvaluationPeriod, setcustomEvaluationPeriod] = useState('');
    const [customEmpId, setcustomEmpId] = useState();
    const [touchbaseClicked, setTouchbaseClicked] = useState(false);
    const [EmpDomain, setEmpDomain] = useState();
    const [container, setContainer] = useState('container');

    const [Tab, setTab] = useState('');
    const [displayTab, setDisplayTab] = useState(true);

    const [leaveCard, setLeaveCard] = useState({});
    const [wfhList, setwfhList] = useState(false);

    let role = encryptStorage.getItem('role');
    let loginEmpId = encryptStorage.getItem('employeeId');
    let search = window.location.search;
    let tab = new URLSearchParams(search).get('tab');
    let params = new URLSearchParams(search);
    let IsTeamMember = params.get('IsTeamMember');
    let EmployeeStatus = params.get('Status');
    const [dependentUrls, setDependentUrls] = useState({});
    const empid = new URLSearchParams(search).get('EmpId')
    // let empid = params.get('emp_id')
    let ToastMessage = sessionStorage.getItem('off');
    // let ToastMessageLeave = encryptStorage.getItem("leave");
    /**
     *  old place of useeffect
     */

    let ProfilrAndCoverImage = {
        cover_img_url: '',
        domain: '',
        emp_name: '',
        profile_img_url: '',
    };
    let EmpPrimaryInfo = {
        emp_id: '',
        aadhar_num: '',
        alternate_num: '',
        anniversary_date: '',
        dob: '',
        domain: '',
        email_id: '',
        emergency_num: '',
        emp_id: '',
        employment_type: '',
        hr_incharge: '',
        joined_date: '',
        marital_status: '',
        pan_card_num: '',
        passport_num: '',
        personal_email: '',
        phone_num: '',
        reports_to: '',
        role: '',
        office_location: '',
        user_id: '',
    };

    const [profileandcoverimage, setprofileandcoverimage] = useState(ProfilrAndCoverImage);
    const [employeeprimaryinfo, setemployeeprimaryinfo] = useState(EmpPrimaryInfo);

    const [attachmentValidation, setattachmentValidation] = useState('');

    let employeeDependent = [];
    const [employeedependent, setEmployeedependent] = useState(employeeDependent);
    const [dependentArrLen, setDependentArrLen] = useState();
    const [EmpId, setEmpId] = useState();
    const [mode, setmode] = useState('');
    const [individualGoal, setIndividualGoal] = useState([]);
    const [teamGoal, setTeamGoal] = useState([]);
    const [individualEvaluation, setIndividualEvaluation] = useState([]);
    const [hideForm, setHideForm] = useState(true);
    const [dependentId, setDependentId] = useState(0);
    const [feedback, setFeedback] = useState(true);
    const [isEmpPrimaryClicked, setIsEmpPrimaryClicked] = useState(false);
    const [isDependentClicked, setIsDependentClicked] = useState(false);
    let [hideFeedbackForm, setHideFeedbackForm] = useState(true);
    let [hideEmployeeInfoForm, setHideEmployeeInfoForm] = useState(true);
    let [hideDependentForm, setHideDependentForm] = useState(true);
    const [reportingEmpIds, setReportingEmpIds] = useState([]);
    const [showOnboardingTab, setShowOnboardingTab] = useState(true);

    const [offboadGridData, setoffboadGridData] = useState();
    const [flag, setFlag] = useState(true);

    const [hideToast, setHideToast] = useState(true);
    const [hideprofileToast, setHideprofileToast] = useState(true);

    const [toastHeaderMessage, setToastHeaderMessage] = useState('');
    const [toastBodyMessage, setToastBodyMessage] = useState('');

    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');

    const [showToastLeave, setShowToastLeave] = useState(false);
    const [ToastValueLeave, setToastValueLeave] = useState('');
    const [ToastColourLeave, setToastColourLeave] = useState('');
    const [ToastParagraphLeave, setToastParagraphLeave] = useState('');
    const [EmployeeGallery, setEmployeeGallery] = useState('');
    const [profileCover, setProfileCover] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    let employee_name = profileandcoverimage.emp_name;
    let breadCrumbsData;


    /**
     * PC_PC_03 useEffect method get invock the api calls
     * and set the values to the state variables
     */

    useEffect(() => {
        setTab('profile');
        if (tab) setTab(tab);
        let Empid = params.get('EmpId');
        //
        // const withoutLineBreaks = empid.replace(/\s/g, '+');
        //
        // let Empid = encryptStorage.decryptValue(`${withoutLineBreaks}`);
        setEmpId(Empid);
        setcustomEmpId(Empid);
        sessionData.login_id = loginEmpId;
        sessionData.role = role;
        setSession({ ...sessionData });
        employeeData.emp_id = Empid;
        employeeData.role = role;
        setEmployeeData({ ...employeeData });
        let EmployeGallery = params.get('EmpGallery');
        //

        if (EmployeGallery == 'true') {
            EmployeeStatus = 'Active';
        }

        if (session.role == 'Team Member') {
            if (Empid == sessionData.login_id) {
                setEmployeeGallery('My Profile');
            } else {
                setEmployeeGallery('Team Member');
            }
        } else if (session.role == 'Manager') {
            if (Empid == sessionData.login_id) {
                setEmployeeGallery('My Profile');
            }
        }

        let EmployeeData = {
            emp_id: Empid,
            role: role,
        };
        getEmpPrimaryDetails(EmployeeData);
        getEmpProfileImages(EmployeeData);
        getEmployeeDependent(EmployeeData);
        myGoal(Empid);
        loadGridPage(Empid);
        LoadReportingEmpIds(Empid);

        if (ToastMessage != undefined && ToastMessage != null) {
            setHideToast(false);
            offboardingToast();

            setTimeout(() => {
                setHideToast(true);
                sessionStorage.removeItem('off');
            }, 2500);
        }
        setShowToastLeave(sessionStorage.getItem('showToast') ? true : false);
        setToastValueLeave(sessionStorage.getItem('showToast') ? sessionStorage.getItem('showToast') : '');
        setToastColourLeave(sessionStorage.getItem('ToastColour') ? sessionStorage.getItem('ToastColour') : '');
        setToastParagraphLeave(sessionStorage.getItem('ToastParagraph') ? sessionStorage.getItem('ToastParagraph') : '');
        if (sessionStorage.getItem('showToast')) {
            setTimeout(() => {
                sessionStorage.removeItem('showToast');
                sessionStorage.removeItem('ToastColour');
                sessionStorage.removeItem('ToastParagraph');
            }, 2500);
        }

        // ((sessionData.role == 'Hr Manager' || sessionData.role == 'Manager') && sessionData.login_id !== EmpId)

        if ((role != 'Hr Manager' || role != 'Manager') && loginEmpId == Empid) {
            setShowOnboardingTab(false);
        }
        // ;
        //
    }, [offboadGridData]);

    useEffect(() => {
        setTimeout(() => {
            setHideToast(true);
            setHideprofileToast(true);
        }, 2500);
    }, [hideToast, hideprofileToast]);

    useEffect(() => {
        myGoal(customEmpId);
        if (customEmpId !== undefined) {
            let obj = { empId: customEmpId };
            getLeaveInED(obj).then((res) => {
                setLeaveCard(res?.data?.ResponseData);
            });
        }
    }, [customEmpId, EmpDomain, customEvaluationPeriod]);

    useEffect(() => {
        let toastCheck = encryptStorage.getItem('goalData');
        if (toastCheck == 'inserted' || toastCheck == 'updated') {
            setToastColor('green');
            if (toastCheck == 'inserted') {
                setToastPara('Goal Evaluation submitted');
                setToastValue('Successfully Submitted');
            }
            if (toastCheck == 'updated') {
                setToastPara('Goal Evaluation updated');
                setToastValue('Successfully Updated');
            }
            setinsertToast(true);
            sessionStorage.removeItem('goalData');
        }
    }, []);

    useEffect(() => {
        const fetchDependentUrls = async () => {
            const urlPromises = employeedependent.map(async (dependent) => {
                const url = dependent.logo_url ? await getS3(dependent.logo_url, "1") : '/Images/profile-dependant-father-icon.svg';
                return [dependent.id, url];
            });
            const urls = await Promise.all(urlPromises);
            setDependentUrls(Object.fromEntries(urls));
        };
        fetchDependentUrls();
    }, [employeedependent]);

    //to get the details whether the user has been applied for the offboarding
    const loadGridPage = async (customEmpId) => {
        //;
        try {
            let empdata = {
                empID: customEmpId,
            };
            setIsLoading(false);
            let data = await getOffboardingDataUser(empdata);
            setoffboadGridData(data?.data?.body?.ResponseData[0]?.length);
            // if (data.data.body.ResponseData[0].length <= 0) {
            //     setFlag(false);
            //     if (tab == 'Offboard') setTab('profile');
            // } else {
            //     if (
            //         customEmpId == sessionData.login_id ||
            //         sessionData.role == 'Hr Manager' ||
            //         sessionData.role == 'Hr' ||
            //         reportingEmpIds.some((emp) => emp.emp_id == customEmpId)
            //     ) {
            //         setFlag(true);
            //     } else {
            //         setFlag(false);
            //         if (tab == 'Offboard') setTab('profile');
            //     }
            // }

            setIsLoading(true);
        } catch (error) {
            //
        }
    };

    //to get the offboarding toast message
    const offboardingToast = () => {
        if (ToastMessage == 1) {
            setToastHeaderMessage('Submitted Successfully');
            setToastBodyMessage('Offboarding applied Successfully');
        } else if (ToastMessage == 2) {
            setToastHeaderMessage('Initiated Successfully');
            setToastBodyMessage('Offboarding has been initiated successfully');
        } else if (ToastMessage == 3) {
            setToastHeaderMessage('Updated Successfully');
            setToastBodyMessage('Offboarding has been updated successfully');
        } else if (ToastMessage == 4) {
            setToastHeaderMessage('Completed Successfully');
            setToastBodyMessage('Offboarding has been completed successfully');
        }
    };

    //leave toast
    const LeaveToast = () => {
        if (ToastMessage == 1) {
            setToastHeaderMessage('Applied');
            setToastBodyMessage('Leave has been applied  Successfully');
        } else if (ToastMessage == 2) {
            setToastHeaderMessage('Rejected');
            setToastBodyMessage('Request has been rejected');
        } else if (ToastMessage == 3) {
            setToastHeaderMessage('Updated Successfully');
            setToastBodyMessage('Leave has been updated successfully');
        } else if (ToastMessage == 4) {
            setToastHeaderMessage('Completed Successfully');
            setToastBodyMessage('Offboarding has been completed successfully');
        }
    };

    /**
     * PC_PC_03.1 set the value for the breadCrumbsData data based on the role
     */

    if (IsTeamMember == 'true' || sessionData.role == 'Team Member') {
        breadCrumbsData = [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'MyProfile', isActive: false, path: '' },
        ];
    } else {
        breadCrumbsData =
            role == 'Admin'
                ? [
                    { title: 'Dashboard', isActive: true, path: '/Overview' },
                    { title: 'Admin', isActive: true, path: '/admin' },
                    { title: 'Team Member', isActive: true, path: '' },
                    { title: 'Team Directory', isActive: true, path: '/TeamDirectory' },
                    { title: employee_name, isActive: false, path: '' },
                ]
                : [
                    { title: 'Dashboard', isActive: true, path: '/Overview' },
                    { title: 'Team Member', isActive: true, path: '' },
                    { title: 'Team Directory', isActive: true, path: '/TeamDirectory' },
                    { title: employee_name, isActive: false, path: '' },
                ];
    }
    /**
     *
     * PC_PC_04 this function will get the data from database
     */
    const getEmpProfileImages = async (EmployeeData) => {
        let responsedata = await getProfileAndCoverImage(EmployeeData);

        let Profileimage = {
            cover_img_url: responsedata?.data?.ResponseData[0][0]?.cover_img_url
                ? await getS3(responsedata?.data?.ResponseData[0][0]?.cover_img_url, "1")
                : '/Images/profile-banner.jpg',
            domain: responsedata?.data.ResponseData[0][0]?.domain,
            emp_name: responsedata?.data.ResponseData[0][0]?.emp_name,
            profile_img_url: responsedata?.data.ResponseData[0][0]?.profile_img_url,
        };
        setprofileandcoverimage(Profileimage);
        setEmpDomain(responsedata?.data?.ResponseData[0][0]?.domain);
        setIsLoading(true);
    };

    /**
     *
     * PC_PC_04.1 this function will get the goal data from database
     */
    const myGoal = async (empid) => {
        let goalData = {
            employeeId: empid,
            evaluation_period_id: customEvaluationPeriod.id,
            domain: EmpDomain,
        };
        let result = await Goal(goalData);
        setIndividualGoal(result?.data?.ResponseData?.individual);
        setTeamGoal(result?.data?.ResponseData?.team);
        setIndividualEvaluation(result?.data?.Evaluation);
    };

    /**
     * PC_PC_04.2 this function will get the TeamMember info from DB
     * and store into the state variable
     *
     */
    const getEmpPrimaryDetails = async (EmpPrimaryData) => {

        try {

            let validReportTo = false;
            switch (encryptStorage.getItem('groupid')) {
                case '1':
                    {
                        validReportTo = true;
                        break;
                    }
                case '2':
                    {

                        if (encryptStorage.getItem('employeeId') == empid) {
                            validReportTo = true;

                        }
                        else {

                            let request = {
                                login_id: encryptStorage.getItem('employeeId'),
                            };
                            let respdata = await getReportingEmpId(request);


                            for (let i = 0; i < respdata?.data?.ResponseData[0]?.length; i++) {
                                if (respdata?.data?.ResponseData[0][i]?.emp_id === empid) {
                                    validReportTo = true;
                                }
                                //
                            }
                        }
                        break;
                    }
                case '3':
                    {
                        if (empid == encryptStorage.getItem('employeeId'))
                            validReportTo = true;
                        break
                    }
                default:
                    {
                        navigate('*')
                        break;
                    }

            }

            if (validReportTo) {

                let responsedata = await getEmployeePrimaryInfo(EmpPrimaryData);
                if (responsedata?.data != undefined && responsedata?.data != null && responsedata?.data?.ResponseData != null) {
                    let m = moment(responsedata?.data?.ResponseData[0][0]?.joined_date).utc();
                    let joinDate = m.format('MMMM DD, YYYY');
                    let bod = moment(responsedata?.data?.ResponseData[0][0]?.dob).utc();
                    let DateOfBirth = responsedata?.data?.ResponseData[0][0]?.dob ? bod.format('MMMM DD, YYYY') : null;
                    let AniverData = moment(responsedata?.data?.ResponseData[0][0]?.anniversary_date).utc();
                    let aniversarydate = AniverData.format('MMMM DD, YYYY');
                    let empPrimaryInfo = {
                        emp_id: responsedata?.data.ResponseData[0][0]?.emp_id,
                        aadhar_num: responsedata?.data.ResponseData[0][0]?.aadhar_num,
                        alternate_num: responsedata?.data.ResponseData[0][0]?.alternate_num,
                        anniversary_date: aniversarydate,
                        dob: DateOfBirth,
                        domain: responsedata?.data?.ResponseData[0][0]?.domain,
                        email_id: responsedata?.data?.ResponseData[0][0]?.email_id,
                        emergency_num: responsedata?.data?.ResponseData[0][0]?.emergency_num,
                        emp_id: responsedata?.data?.ResponseData[0][0]?.emp_id,
                        employment_type: responsedata?.data?.ResponseData[0][0]?.employment_type,
                        hr_incharge: responsedata?.data?.ResponseData[0][0]?.hr_incharge,
                        joined_date: joinDate,
                        marital_status: responsedata?.data?.ResponseData[0][0]?.marital_status,
                        pan_card_num: responsedata?.data?.ResponseData[0][0]?.pan_card_num,
                        passport_num: responsedata?.data?.ResponseData[0][0]?.passport_num,
                        personal_email: responsedata?.data?.ResponseData[0][0]?.personal_email,
                        phone_num: responsedata?.data?.ResponseData[0][0]?.phone_num,
                        reports_to: responsedata?.data?.ResponseData[0][0]?.reports_to,
                        role: responsedata?.data?.ResponseData[0][0]?.role,
                        office_location: responsedata?.data?.ResponseData[0][0]?.office_location,
                        user_id: responsedata?.data?.ResponseData[0][0]?.userid,
                    };
                    setemployeeprimaryinfo(empPrimaryInfo);
                }
            }
            else {
                navigate('/', { state: { hideNav: false } });
            }

        } catch (e) { }
    };

    const LoadReportingEmpIds = async (Empid) => {
        //;
        let loginEmpData = { login_id: loginEmpId };
        let responsedata = await getReportingEmpId(loginEmpData);
        if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {
            setReportingEmpIds(responsedata?.data?.ResponseData[0]);
        }
        if (
            Empid == sessionData.login_id ||
            sessionData.role == 'Hr Manager' ||
            sessionData.role == 'Hr' ||
            responsedata.data.ResponseData[0].some((emp) => emp.emp_id == Empid)
        ) {
            setDisplayTab(true);
        } else {
            setDisplayTab(false);
        }

        if (offboadGridData <= 0) {
            setFlag(false);
            // if (tab == 'Offboard') setTab('profile');
        } else {
            if (
                Empid == sessionData.login_id ||
                sessionData.role == 'Hr Manager' ||
                sessionData.role == 'Hr' ||
                responsedata.data.ResponseData[0].some((emp) => emp.emp_id == Empid)
            ) {
                setFlag(true);
                // if (tab == 'Offboard') setTab('Offboard');
            } else {
                setFlag(false);
                // if (tab == 'Offboard') setTab('profile');
            }
        }
    };

    const MessageText = (headerMessage, bodyMessage) => {
        setHideToast(false);
        setToastHeaderMessage(headerMessage);
        setToastBodyMessage(bodyMessage);
        // if (Mode == 'Save') {
        //     setToastHeaderMessage('Submitted Succesfull');
        //     setToastBodyMessage('toast paragraph');
        // } else if (Mode == 'Update') {

        // }
    };

    /**
     *
     * PC_PC_04.3 get the data from Database and set into the state variable
     */
    const getEmployeeDependent = async (EmployeeData) => {
        //;
        try {
            let responsedata = await getEmployeeDependentInfo(EmployeeData);
            setEmployeedependent(responsedata.data.ResponseData[0]);
            setDependentArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    /**
     *
     * PC_PC_13 this function will post the url into the database
     */
    const PostBackgroundImage = async (url) => {
        let payload = {
            emp_id: EmpId,
            cover_url: url,
        };

        try {
            let responsedata = await postCoverImage(payload);
            if (responsedata.data.status == 200) {
                let EmployeeData = {
                    emp_id: EmpId,
                };
                getEmpProfileImages(EmployeeData);
            }
        } catch (e) { }
    };
    /**
     * PC_PC_30  below functions are set the value into the state variables
     */
    const PrimaryInfoEditClick = () => {
        setEmpId(EmpId);
        setmode('Edit');
        setIsEmpPrimaryClicked(true);
        setHideEmployeeInfoForm(false);
    };

    const DependentAddclick = () => {
        setDependentId(0);
        setmode('');
        setIsDependentClicked(true);
        setHideDependentForm(false);
    };

    const DependentEditclick = (e) => {
        setDependentId(e.target.id);
        setmode('Edit');
        setIsDependentClicked(true);
        setHideDependentForm(false);
    };

    const FeedbackTabClick = () => {
        setFeedback(true);
    };

    const evaluationPeriodTrigger = (value) => {
        setcustomEvaluationPeriod(value);
    };

    /**
     *
     * PC_PC_10 this function will bind and retirn the Dependent data to html
     */
    const buildDependentBody = () => {
        try {
            return employeedependent.map((obj, index) => {
                const imageSrc = dependentUrls[obj.id] || '/Images/profile-dependant-father-icon.svg';
                return (
                    <div className="profile-list-panel">
                        <div className="profile-list-label">{obj.relationshiptype}</div>
                        <div className="profile-list-value">
                            {EmpId == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr' ? (
                                <a
                                    className="btn btn-primary profile-btn-dependant"
                                    role="button"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#Dependants"
                                    id={obj?.id}
                                    onClick={(e) => DependentEditclick(e)}
                                >
                                    <img src={imageSrc} alt={obj?.name} /> {obj?.name}
                                </a>
                            ) : (
                                <span>
                                    <img src={imageSrc} alt={obj?.name} /> {obj?.name}
                                </span>
                            )}
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_PC_11.1 this function will validate and upload the file into the S3 bucket
     */
    const fileUpload = async (e) => {
        let dirName = `${EmpId}-Profile-bg-img`;
        if (e.target.files[0]) {
            let file = e.target.files[0];
            let newFileName = file.name;
            if (file && newFileName) {
                const typeArr = ['jpg', 'png', 'svg+xml', 'jpeg', 'svg'];
                let type = typeArr.includes(file.type.split('/')[1]);

                if (file.size >= 2000000) {
                    setattachmentValidation('File size should be less than 2MB');
                    setHideprofileToast(false);
                    return;
                } else if (!type) {
                    setattachmentValidation('The uploaded file should be in JPG, PNG, JPEG, SVG format');
                    setHideprofileToast(false);
                    return;
                } else {
                    setattachmentValidation('');
                    setHideprofileToast(true);
                }

                if (file.size <= 2000000 && type) {
                    setIsLoading(true);

                    let formData = new FormData();
                    formData.append('file', file);
                    try {
                        let fileLocation = await uploadBackend(file, newFileName, dirName);
                        
                        if (fileLocation) {
                            setImageUrl(fileLocation); // Set the image URL to state
                            PostBackgroundImage(fileLocation);
                            setHideprofileToast(true);
                        }else {
                            setattachmentValidation('File upload failed. Please try again.');
                            setHideprofileToast(false);
                        }
                    } catch (error) {
                        setattachmentValidation('File upload failed. Please try again.');
                        setHideprofileToast(false);
                    } finally {
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(true);
                }
            } else {
                setIsLoading(true);
            }
        }
    };

    const AssgignGoal = (type) => {
        navigate('/goaltemplate', {
            state: {
                type: type,
                View: true,
                redirect: search,
                profileBreadcrumbs: breadCrumbsData,
                employeeId: type == 'individual' ? EmpId : '',
            },
        });
    };

    const addFeedbackClicked = () => {
        setHideFeedbackForm(false);
    };

    const ApplyRender = () => {
        try {
            if (sessionData.role == 'Team Member') {
                return (
                    <div className="me-4">
                        {EmployeeStatus != 'Inactive' && (EmployeeGallery == '' || EmployeeGallery == 'My Profile') ? (
                            <div className="dropdown d-inline p-1">
                                <button
                                    className="btn profile-btn dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Apply
                                </button>
                                <ul className="dropdown-menu profile-dropdown-menu-bg" aria-labelledby="dropdownMenuButton1">
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a className="dropdown-item" href="/wfhform?IsTeamMember=true">
                                                WFH
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a className="dropdown-item" href="/leaveform?IsTeamMember=true">
                                                Leave
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a
                                                className="dropdown-item"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    navigate('/concernForm', { state: { way: 'MyProfile' } });
                                                }}
                                            >
                                                Concern
                                            </a>
                                        </li>
                                    ) : null}

                                    <li className="profile-dropdown-TD">
                                        <a
                                            className="dropdown-item"
                                            href={
                                                IsTeamMember == 'true'
                                                    ? `/offboardingForm?emp_id=${EmpId}&emp_name=${profileandcoverimage.emp_name}&emp_domain=${profileandcoverimage.domain}&IsTeamMember=true`
                                                    : `/offboardingForm?emp_id=${EmpId}&emp_name=${profileandcoverimage.emp_name}&emp_domain=${profileandcoverimage.domain}`
                                            }
                                        >
                                            Offboarding
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        ) : null}
                        {/* <button className="btn profile-btn" type="file"  >
                     <img src="/Images/profile-update.svg" alt="Profile Update Icon" />
                     Edit</button> */}
                        {EmpId == sessionData.login_id ? (
                            <label for="voterid-upload" className="btn profile-btn">
                                <img className="me-2" src="/Images/profile-update.svg" alt="Upload Icon" />
                                Edit
                                <input id="voterid-upload" className="profile-file-upload" type="file" onChange={(e) => fileUpload(e)} />
                            </label>
                        ) : null}
                    </div>
                );
            } else if (sessionData.role == 'Manager') {
                return (
                    <div className="me-4">
                        {EmployeeStatus != 'Inactive' &&
                            (reportingEmpIds.some((emp) => emp.emp_id == EmpId) || EmpId == sessionData.login_id) ? (
                            <div className="dropdown d-inline p-1">
                                <button
                                    className="btn profile-btn dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Apply
                                </button>
                                <ul className="dropdown-menu profile-dropdown-menu-bg" aria-labelledby="dropdownMenuButton1">
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a className="dropdown-item" href="/wfhform?IsTeamMember=true">
                                                WFH
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a className="dropdown-item" href="/leaveform?IsTeamMember=true">
                                                Leave
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a
                                                className="dropdown-item"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    navigate('/concernForm', { state: { way: 'MyProfile' } });
                                                }}
                                            >
                                                Concern
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId != sessionData.login_id && role != 'Hr' && reportingEmpIds.some((emp) => emp.emp_id == EmpId) ? (
                                        <li className="profile-dropdown-TD">
                                            <a
                                                className="dropdown-item "
                                                style={{ cursor: 'pointer' }}
                                                // data-bs-toggle="modal"
                                                // data-bs-target="#AddFeedbackDetailsPopupContainer"
                                                onClick={() => addFeedbackClicked()}
                                            >
                                                Add Feedback
                                            </a>
                                        </li>
                                    ) : null}

                                    <li className="profile-dropdown-TD">
                                        <a
                                            className="dropdown-item"
                                            href={
                                                IsTeamMember == 'true'
                                                    ? `/offboardingForm?emp_id=${EmpId}&emp_name=${profileandcoverimage.emp_name}&emp_domain=${profileandcoverimage.domain}&IsTeamMember=true`
                                                    : `/offboardingForm?emp_id=${EmpId}&emp_name=${profileandcoverimage.emp_name}&emp_domain=${profileandcoverimage.domain}`
                                            }
                                        >
                                            Offboarding
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        ) : null}
                        {/* <button className="btn profile-btn" type="file"  >
                 <img src="/Images/profile-update.svg" alt="Profile Update Icon" />
                 Edit</button> */}
                        {EmpId == sessionData.login_id ||
                            sessionData.role == 'Team Member' ||
                            sessionData.role == 'Hr Manager' ||
                            sessionData.role == 'Hr' ? (
                            <label for="voterid-upload" className="btn profile-btn">
                                <img className="me-2" src="/Images/profile-update.svg" alt="Upload Icon" />
                                Edit
                                <input id="voterid-upload" className="profile-file-upload" type="file" onChange={(e) => fileUpload(e)} />
                            </label>
                        ) : null}
                    </div>
                );
            } else {
                return (
                    <div className="me-4">
                        {EmployeeStatus != 'Inactive' ? (
                            <div className="dropdown d-inline p-1">
                                <button
                                    className="btn profile-btn dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    onClick={(e) => {
                                        setwfhList(true)
                                    }}
                                >
                                    Apply
                                </button>
                                <ul className={wfhList == true ? `dropdown-menu profile-dropdown-menu-bg show` : "dropdown-menu profile-dropdown-menu-bg"} aria-labelledby="dropdownMenuButton1">
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a className="dropdown-item" href="/wfhform?IsTeamMember=true">
                                                WFH
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a className="dropdown-item" href="/leaveform?IsTeamMember=true">
                                                Leave
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId == sessionData.login_id ? (
                                        <li className="profile-dropdown-TD">
                                            <a
                                                className="dropdown-item"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    navigate('/concernForm', { state: { way: 'MyProfile' } });
                                                }}
                                            >
                                                Concern
                                            </a>
                                        </li>
                                    ) : null}
                                    {EmpId != sessionData.login_id && role != 'Hr' && reportingEmpIds.some((emp) => emp.emp_id == EmpId) ? (
                                        <li className="profile-dropdown-TD">
                                            <a
                                                className="dropdown-item "
                                                style={{ cursor: 'pointer' }}
                                                // data-bs-toggle="modal"
                                                // data-bs-target="#AddFeedbackDetailsPopupContainer"
                                                onClick={() => addFeedbackClicked()}
                                            >
                                                Add Feedback
                                            </a>
                                        </li>
                                    ) : null}

                                    <li className="profile-dropdown-TD">
                                        <a
                                            className="dropdown-item"
                                            href={
                                                IsTeamMember == 'true'
                                                    ? `/offboardingForm?emp_id=${EmpId}&emp_name=${profileandcoverimage.emp_name}&emp_domain=${profileandcoverimage.domain}&IsTeamMember=true`
                                                    : `/offboardingForm?emp_id=${EmpId}&emp_name=${profileandcoverimage.emp_name}&emp_domain=${profileandcoverimage.domain}`
                                            }
                                        >
                                            Offboarding
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        ) : null}
                        {/* <button className="btn profile-btn" type="file"  >
                 <img src="/Images/profile-update.svg" alt="Profile Update Icon" />
                 Edit</button> */}
                        {EmpId == sessionData.login_id ||
                            sessionData.role == 'Team Member' ||
                            sessionData.role == 'Hr Manager' ||
                            sessionData.role == 'Hr' ? (
                            <label for="voterid-upload" className="btn profile-btn">
                                <img className="me-2" src="/Images/profile-update.svg" alt="Upload Icon" />
                                Edit
                                <input id="voterid-upload" className="profile-file-upload" type="file" onChange={(e) => fileUpload(e)} />
                            </label>
                        ) : null}
                    </div>
                );
            }
        } catch (e) {
            throw e;
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            {showToastLeave ? (
                <EvaluationPopUp
                    color={ToastColourLeave}
                    Page={'Success Insert'}
                    Heading={ToastValueLeave}
                    Paragraph={ToastParagraphLeave}
                />
            ) : (
                <></>
            )}
            <div className="profile-parent-container mt-5">
                <div className="col-md-11 mt-5">
                    <BreadCrumbs data={breadCrumbsData} />
                </div>

                <div className="position-fixed col-md-12 position-toast d-flex justify-content-center end-0 p-3" style={{ zIndex: 11 }}>
                    <div
                        id="liveToast"
                        className="toast side-toast show"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        hidden={hideToast}
                    >
                        <div className="col-md-12 p-2 float-start">
                            <div className>
                                <div className="toast-header border-toast">
                                    <img className="tick px-2 float-start" src="/Images/green-tick.svg" alt="toast" />
                                    <div className="float-start px-3 pe-3">
                                        <div className="bold-text font-18 toast-font-black">
                                            {toastHeaderMessage == '' ? 'Submitted' : toastHeaderMessage}
                                        </div>
                                        <div className="body-toast semibold-text font-12 toast-font-grey ">
                                            {toastBodyMessage == '' ? 'Submitted Succesfully' : toastBodyMessage}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="position-fixed col-md-12 position-toast d-flex justify-content-center end-0 p-3" style={{ zIndex: 11 }}>
                    <div
                        id="liveToast"
                        className="toast Profile-Red-toast show"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        hidden={hideprofileToast}
                    >
                        <div className="col-md-12 p-2 float-start">
                            <div className>
                                <div className="toast-header border-toast">
                                    <img className="tick px-2 float-start" src="/Images/Cross-tick.svg" alt="toast" />
                                    <div className="float-start px-3 pe-3">
                                        <div className="bold-text font-18 toast-font-black"> {attachmentValidation}</div>
                                        {/* <div className="body-toast semibold-text font-12 toast-font-grey "> error paragraph</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid bg-white profile-rounded">
                    <div className="row">
                        <div className="col-md-9 profile-custom-border" id="expand-panel">
                            <div className="row">
                                <div className="col-md-12 px-0">
                                    <div className="card  text-white border-0">
                                        <img
                                            className="card-img profile-banner-img bg-dark"
                                            src={profileandcoverimage?.cover_img_url}
                                            alt="Profile Banner"
                                        />
                                        <div className="card-img-overlay p-4">
                                            <img src="/Images/profile-collapse-back.svg" id="profile-collapse-back" alt="" />
                                            <div className="profile-spacing">
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        className="float-start profile-picture"
                                                        src={
                                                            profileandcoverimage.profile_img_url
                                                                ? profileandcoverimage.profile_img_url
                                                                : '/Images/logo-person-user-person-icon.jpg'
                                                        }
                                                        alt="User Image"
                                                        style={{ background: 'white' }}
                                                    />
                                                    <div className="float-start">
                                                        <span className="card-title d-block font-18 bold-text mb-0">
                                                            {profileandcoverimage.emp_name}
                                                        </span>
                                                        <span className="card-text bold-text font-14">{profileandcoverimage.domain}</span>
                                                    </div>
                                                </div>
                                                {ApplyRender()}
                                            </div>
                                            <ul className="nav nav-tabs card-header-tabs position-absolute profile-bottom-20 ms-0">
                                                <li
                                                    className="nav-item me-4"
                                                    onClick={() => {
                                                        setTab('');
                                                    }}
                                                >
                                                    <a
                                                        className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab == 'profile' ? 'active' : ''
                                                            }`}
                                                        id="profile-tab"
                                                    >
                                                        Profile
                                                    </a>
                                                </li>

                                                {displayTab ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab === 'performance' ? 'active' : ''
                                                                }`}
                                                            id="performance-tab"
                                                        >
                                                            Performance
                                                        </a>
                                                    </li>
                                                ) : null}

                                                {displayTab ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab == 'Leave' ? 'active' : ''
                                                                }`}
                                                            id="leave-tab"
                                                        >
                                                            Leave
                                                        </a>
                                                    </li>
                                                ) : null}

                                                {displayTab ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab == 'Touchbase' ? 'active' : ''
                                                                }`}
                                                            id="touchbase-tab"
                                                        >
                                                            Touchbase
                                                        </a>
                                                    </li>
                                                ) : null}
                                                {displayTab ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab == 'feedback' ? 'active' : null
                                                                }`}
                                                            id="feedbacks-tab"
                                                            onClick={() => FeedbackTabClick()}
                                                        >
                                                            Feedback
                                                        </a>
                                                    </li>
                                                ) : null}
                                                {displayTab ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab == 'Salary' ? 'active' : ''
                                                                }`}
                                                            id="salaryrevision-tab"
                                                        >
                                                            Salary Revision
                                                        </a>
                                                    </li>
                                                ) : null}

                                                {/* {((sessionData.role == 'Hr Manager' || sessionData.role == 'Manager') && sessionData.login_id !== EmpId)  */}

                                                {showOnboardingTab && displayTab ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1 ${Tab == 'Onboarding' ? 'active' : ''
                                                                }`}
                                                            id="onboarding-tab"
                                                        >
                                                            Onboarding Details
                                                        </a>
                                                    </li>
                                                ) : null}
                                                {flag ? (
                                                    <li
                                                        className="nav-item me-4"
                                                        onClick={() => {
                                                            setTab('');
                                                        }}
                                                    >
                                                        <a
                                                            className={`nav-link profile-nav-link cursor border-0 px-0 py-1  ${Tab == 'Offboard' ? 'active' : ''
                                                                }`}
                                                            id="offboarding-tab"
                                                        >
                                                            Offboarding
                                                        </a>
                                                    </li>
                                                ) : null}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Tabbed Content for Profile starts here */}
                            <div
                                className="row"
                                id="profile-tab-content"
                                style={Tab == 'profile' ? { display: 'flex' } : { display: 'none' }}
                            >
                                {/* PC_PC_21 profil.jsx component will render here */}
                                {
                                    <Profile
                                        empId={EmpId}
                                        setHideToast={(headerMessage, bodyMessage) => MessageText(headerMessage, bodyMessage)}
                                    />
                                }
                                {/* setHideToast */}
                            </div>
                            {/* Tabbed Content for Profile ends here */}
                            {/* Tabbed Content for Performance starts here */}
                            <div
                                className={`row  ${Tab == 'performance' ? 'd-flex' : null}`}
                                id="performance-tab-content" /* style={Tab == 'performance' ? { display: 'block' } : { display: 'none' }} */
                            >
                                <div className="mt-2">
                                    <div className="col-md-12">
                                        <div
                                            className="d-flex float-left tt-bold px-0 font-16 bold-text rounded-0"
                                            style={{ margin: '10px 0px 0px 15px' }}
                                        >
                                            Performance
                                        </div>
                                        <div className="d-flex float-right">
                                            <label className="text-blue font-12 medium-text label-text me-2 float-start mt-2 mt-10px">
                                                Evaluation Period
                                            </label>
                                            <EvaluationButton
                                                dataChange={(value) => {
                                                    evaluationPeriodTrigger(value);
                                                }}
                                            />
                                            {sessionData.role !== 'Team Member' &&
                                                sessionData.login_id !== EmpId &&
                                                EmployeeStatus != 'Inactive' ? (
                                                <>
                                                    <button
                                                        className="btn hive-btn-primary dropdown-toggle"
                                                        type="button"
                                                        id="dropdownMenuButton1"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <img src="/Images/add.svg" alt="add-arrow" className />{' '}
                                                        <span className="right-arrow">New Goal</span>
                                                    </button>
                                                    <ul
                                                        className="dropdown-menu shadow custom-assign-button border-0"
                                                        aria-labelledby="dropdownMenuButton1"
                                                    >
                                                        <li
                                                            onClick={() => {
                                                                AssgignGoal('team');
                                                            }}
                                                        >
                                                            <a className="dropdown-item">Team Goal</a>
                                                        </li>
                                                        <li
                                                            onClick={() => {
                                                                AssgignGoal('individual');
                                                            }}
                                                        >
                                                            <a className="dropdown-item">Individual Goal</a>
                                                        </li>
                                                    </ul>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                    {/* PC_PC_22 MyGoal.jsx component will remder here */}
                                </div>
                                {customEvaluationPeriod !== undefined && customEvaluationPeriod !== null ? (
                                    <MyGoal
                                        View={true}
                                        Custom={true}
                                        CustomEmpId={EmpId}
                                        CustomDomain={EmpDomain}
                                        EmployeeEvaluation={individualEvaluation}
                                        Individual={individualGoal}
                                        Team={teamGoal}
                                        Evaluation={customEvaluationPeriod}
                                        BreadCrumbsProfile={breadCrumbsData}
                                        MyGoal={myGoal}
                                    />
                                ) : null}
                            </div>
                            {/* Tabbed Content for Performance ends here */}
                            {/* Tabbed Content for Leave starts here */}

                            {/* PC_PC_23 Whf.jsx component will render here */}
                            <div className={`row ${Tab == 'Leave' ? 'd-flex' : null}  `} id="leave-tab-content">
                                {customEmpId !== undefined && EmpDomain !== undefined ? (
                                    <Wfh EmployeeId={customEmpId} leaveCount={leaveCard} Domain={EmpDomain} />
                                ) : null}
                            </div>
                            {/* Tabbed Content for Leave ends here */}
                            {/* Tabbed Content for Touchbase starts here */}

                            {/* PC_PC_24 Touchbase.jsx component will rendenr here */}
                            <div
                                onClick={() => {
                                    setTouchbaseClicked(true);
                                }}
                                className={`row ${Tab == 'Touchbase' ? 'd-flex' : null}  `}
                                id="touchbase-tab-content"
                            >
                                {customEmpId !== undefined && EmpDomain !== undefined ? (
                                    <Touchbase
                                        IsTeamMember={IsTeamMember}
                                        View={true}
                                        EmployeeId={customEmpId}
                                        Domain={EmpDomain}
                                        EmployeeName={profileandcoverimage.emp_name}
                                        EmployeeStatus={EmployeeStatus}
                                    />
                                ) : null}
                            </div>
                            {/* Tabbed Content for Touchbase ends here */}
                            {/* Tabbed Content for Feedbacks starts here */}

                            {/* PC_PC_25 ProfileFeedbackTab.jsx  component will here*/}
                            <div className={`row ${Tab == 'feedback' ? 'd-flex' : null}  `} id="feedbacks-tab-content">
                                {EmpId != undefined ? (
                                    <ProfileFeedbackTabGrid
                                        empId={EmpId}
                                        iscurrent={feedback}
                                        emp_name={profileandcoverimage.emp_name}
                                        emp_domain={profileandcoverimage.domain}
                                        isTeamMember={IsTeamMember}
                                        reportingEmpIds={reportingEmpIds}
                                        EmployeeStatus={EmployeeStatus}
                                    />
                                ) : null}
                            </div>
                            {/* Tabbed Content for Feedbacks ends here */}
                            {/* Tabbed Content for Salary Revision starts here */}

                            {/* PC_PC_26 salaryRevisionGrid.jsx will render here */}
                            <div className={`row ${Tab == 'Salary' ? 'd-flex' : null}  `} id="salaryrevision-tab-content">
                                <SalaryRevisionGrid
                                    empId={EmpId}
                                    emp_name={profileandcoverimage.emp_name}
                                    emp_domain={profileandcoverimage.domain}
                                    EmployeeStatus={EmployeeStatus}
                                />
                            </div>
                            {/* Tabbed Content for Salary Revision ends here */}
                            {/* Tabbed Content for Onboarding Details starts here */}

                            {/* PC_PC_27 OnboardingGrid.jsx will render here */}
                            <div
                                className={`row ${Tab == 'Onboarding' ? 'd-flex' : null}  `}
                                id="onboarding-tab-content" /* style={Tab == 'Onboarding' ? { display: 'flex' } : { display: 'none' }} */
                            >
                                {customEmpId !== undefined ? (
                                    <OnboardingDetails empId={customEmpId} emp_name={profileandcoverimage.emp_name} />
                                ) : null}
                            </div>
                            {/* Tabbed Content for Onboarding Details ends here */}
                            {/* Tabbed Content for Offboarding starts here */}

                            {/* PC_PC_28 OffboardingGrid.jsx */}

                            <div
                                className={`row ${Tab == 'Offboard' ? 'd-flex' : null}  `}
                                id="offboarding-tab-content" /*style={Tab == 'Offboard' ? { display: 'flex' } : { display: 'none' }} */
                            >
                                {customEmpId !== undefined ? (
                                    <OffboardingGrid empId={customEmpId} EmployeeStatus={EmployeeStatus} isProfile={true} />
                                ) : null}
                            </div>
                            {/* Tabbed Content for Offboarding ends here */}
                        </div>
                        <div className="col-md-3 ps-4" id="right-panel">
                            <img id="demo" src="/Images/profile-collapse.svg" alt="Collapse Icon" />
                            {/* Basic Info*/}
                            <ul className="list-group mt-4">
                                <li className="list-group-item profile-list-group-item border-0">
                                    <img className="me-3" src="/Images/profile-location-icon.svg" />
                                    {employeeprimaryinfo.office_location}
                                </li>
                                <li className="list-group-item profile-list-group-item border-0">
                                    <img className="me-3" src="/Images/profile-email-icon.svg" />
                                    <a className="text-decoration-none">{employeeprimaryinfo.email_id}</a>
                                </li>
                                <li className="list-group-item profile-list-group-item profile-contact-color border-0">
                                    <img className="me-3" src="/Images/profile-contact-icon.svg" />
                                    {employeeprimaryinfo.phone_num}
                                    {/* {employeeprimaryinfo.phone_num.length >= 5 ? employeeprimaryinfo.phone_num.substring(0, 5) + ' ' : ''}
                                    {employeeprimaryinfo.phone_num.length >= 6 ? employeeprimaryinfo.phone_num.substring(5, 10) : ''} */}
                                </li>
                            </ul>
                            {/* Basic Info*/}
                            {/* Team Member Info */}
                            <div className="profile-spacing mt-3">
                                <div className="profile-header-title">Team Member Info</div>
                                {EmpId == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr' ? (
                                    <div className="profile-edit-panel" onClick={() => PrimaryInfoEditClick()}>
                                        <a
                                            href="#"
                                            className="profile-edit"
                                        //data-bs-toggle="modal" data-bs-target="#employeeinfo"
                                        >
                                            <img src="/Images/edit darkgrey.svg" alt="Edit Icon" className="p-1" />
                                            Edit
                                        </a>
                                    </div>
                                ) : null}
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Emp ID</div>
                                <div className="profile-list-value">{employeeprimaryinfo.user_id}</div>
                                {/* emp_id */}
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Domain</div>
                                <div className="profile-list-value">{employeeprimaryinfo.domain}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Role</div>
                                <div className="profile-list-value">{employeeprimaryinfo.role}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Reports to</div>
                                <div className="profile-list-value">{employeeprimaryinfo.reports_to}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">HR In-charge</div>
                                <div className="profile-list-value">{employeeprimaryinfo.hr_incharge}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">DOJ</div>
                                <div className="profile-list-value">
                                {(employeeprimaryinfo.joined_date != "Invalid date") ? employeeprimaryinfo.joined_date + ' ' : '-'}
                                   </div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Employment Type </div>
                                <div className="profile-list-value">{employeeprimaryinfo.employment_type}</div>
                            </div>
                            {/* Team Member Info */}
                            {/* Primary Info */}
                            <div className="profile-spacing mt-3">
                                <div className="profile-header-title">Primary Info</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">DOB</div>
                                <div className="profile-list-value">
                                    {employeeprimaryinfo.dob ? employeeprimaryinfo.dob + ' ' : '-'}
                                    {employeeprimaryinfo.dob ? (
                                        <img src="/Images/profile-birthdaycake-icon.svg" alt="Birthday Icon" />
                                    ) : null}
                                </div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Personal Email ID</div>
                                <div className="profile-list-value">{employeeprimaryinfo.personal_email}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Alternate Number</div>
                                <div className="profile-list-value">
                                    {employeeprimaryinfo?.alternate_num?.length >= 5
                                        ? employeeprimaryinfo?.alternate_num?.substring(0, 5) + ' '
                                        : ''}
                                    {employeeprimaryinfo?.alternate_num?.length >= 6
                                        ? employeeprimaryinfo?.alternate_num?.substring(5, 10)
                                        : ''}
                                </div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Marital Status</div>
                                <div className="profile-list-value">{employeeprimaryinfo.marital_status}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Anniversary Date</div>
                                <div className="profile-list-value">
                                    {employeeprimaryinfo.marital_status == 'Unmarried' || employeeprimaryinfo.marital_status == 'UnMarried'
                                        ? '-'
                                        : employeeprimaryinfo.anniversary_date}
                                </div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Emergency Number</div>
                                <div className="profile-list-value">
                                    {employeeprimaryinfo?.emergency_num?.length >= 5
                                        ? employeeprimaryinfo?.emergency_num?.substring(0, 5) + ' '
                                        : ''}
                                    {employeeprimaryinfo?.emergency_num?.length >= 6
                                        ? employeeprimaryinfo?.emergency_num?.substring(5, 10)
                                        : ''}
                                </div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Aadhaar Card</div>
                                <div className="profile-list-value">
                                    {employeeprimaryinfo?.aadhar_num?.length >= 4 ? employeeprimaryinfo?.aadhar_num?.substring(0, 4) + ' ' : ''}
                                    {employeeprimaryinfo?.aadhar_num?.length >= 8 ? employeeprimaryinfo?.aadhar_num?.substring(4, 8) + ' ' : ''}
                                    {employeeprimaryinfo?.aadhar_num?.length >= 12
                                        ? employeeprimaryinfo?.aadhar_num?.substring(8, 12) + ' '
                                        : ''}
                                </div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">PAN Card</div>
                                <div className="profile-list-value">{employeeprimaryinfo.pan_card_num}</div>
                            </div>
                            <div className="profile-list-panel">
                                <div className="profile-list-label">Passport No.</div>
                                <div className="profile-list-value">{employeeprimaryinfo.passport_num}</div>
                            </div>
                            {/* Primary Info */}
                            {/* Dependant Panel*/}
                            <div className="profile-spacing mt-3">
                                <div className="profile-header-title">
                                    Dependents (<span>{dependentArrLen}</span>)
                                </div>
                                {dependentArrLen > 0 &&
                                    (EmpId == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                    <div className="profile-panel">
                                        <a
                                            href="#"
                                            className="profile-add-dependant text-decoration-none"
                                            // data-bs-toggle="modal"
                                            // data-bs-target="#Dependants"
                                            onClick={() => DependentAddclick()}
                                        >
                                            <img src="/Images/profile-add-icon.svg" alt="Add Icon" className="p-1" />
                                            Add New
                                        </a>
                                    </div>
                                ) : null}
                            </div>
                            {dependentArrLen <= 0 &&
                                (EmpId == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => DependentAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            className="profile-add"
                                            onClick={() => DependentAddclick()}
                                        // data-bs-toggle="modal"
                                        // data-bs-target="#Dependants"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add Family Members</span>
                                        </a>
                                    </div>
                                </div>
                            ) : null}
                            {buildDependentBody()}
                            {/* Dependant Panel*/}
                        </div>
                    </div>
                </div>

                {/* PC_PC_31 bellow component will render based on button click */}
                <AddFeedback
                    empId={EmpId}
                    empName={profileandcoverimage.emp_name}
                    empDomain={profileandcoverimage.domain}
                    from={container}
                    ReloadGridPage={null}
                    hideFeedbackForm={hideFeedbackForm}
                    setHideFeedbackForm={() => setHideFeedbackForm()}
                />

                <EmployeeInfo
                    empId={EmpId}
                    Mode={mode}
                    isEmpPrimaryClick={isEmpPrimaryClicked}
                    setIsEmpPrimaryClicked={() => setIsEmpPrimaryClicked()}
                    getEmpPrimaryDetails={() => getEmpPrimaryDetails(employeeData)}
                    hideEmployeeInfoForm={hideEmployeeInfoForm}
                    setHideEmployeeInfoForm={() => setHideEmployeeInfoForm()}
                    setHideToast={(headerMessage, bodyMessage) => MessageText(headerMessage, bodyMessage)}
                />
                <DependentDetails
                    empId={EmpId}
                    Id={dependentId}
                    Mode={mode}
                    isDependentClicked={isDependentClicked}
                    setIsDependentClicked={() => setIsDependentClicked()}
                    getEmployeeDependent={() => getEmployeeDependent(employeeData)}
                    hideDependentForm={hideDependentForm}
                    setHideDependentForm={() => setHideDependentForm()}
                    setHideToast={(headerMessage, bodyMessage) => MessageText(headerMessage, bodyMessage)}
                />
            </div>
        </>
    );
}
export default ProfileContainer;
